export const IconFacebook = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M13.3197 20.1453V11.5717H15.6864L16 8.61713H13.3197L13.3237 7.13836C13.3237 6.36777 13.3969 5.95487 14.5037 5.95487H15.9832V3H13.6162C10.773 3 9.77227 4.43327 9.77227 6.84357V8.61747H8V11.572H9.77227V20.1453H13.3197Z" />
  </svg>
);
IconFacebook.displayName = 'IconFacebook';
